// extracted by mini-css-extract-plugin
module.exports = {"form_layout_v2_content":"form-layout-v2_form_layout_v2_content__3WrPg"};